import styled from "styled-components";

export const OrderFieldsLabels = styled.div`
    display: flex;
    justify-content: center;
`;
export const OrderFieldsLabelsWrapper = styled.div`
    border-radius: 5px;
    margin: 20px;
    width: calc(100% - 40px);
    border: 1px solid #e7e7eb;
`;

export const OrderFieldsLabelsContent = styled.div`
    margin: 25px;
    height: 450px;
    display: flex;
    gap: 50px;
`;

export const OrderFieldsLabelsItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const OrderFieldsLabelsContentTitle = styled.div`
  color: #666667;
  font-weight: 600;
`;


export const OrderFieldsTagging = styled.div`
    display: flex;
    justify-content: center;
`;
export const OrderFieldsTaggingWrapper = styled.div`
    border-radius: 5px;
    margin: 20px;
    width: calc(100% - 40px);
    border: 1px solid #e7e7eb;
`;

export const OrderFieldsTaggingContent = styled.div`
    margin: 25px;
    height: 500px;
    display: flex;
    gap: 30px;
`;

export const OrderFieldsTaggingLeft = styled.div`
  width: 50%;
  
`;
export const OrderFieldsTaggingRight = styled.div`
  width: 50%;
  position: relative;
`;
export const OrderFieldsTaggingItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const OrderFieldsTaggingContentTitle = styled.div`
  color: #666667;
  font-weight: 600;
  width: 100%;
`;


export const OrderFieldsTaggingFields = styled.div`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow: auto;
  max-height: 475px;
  padding-right: 5px;
`;
export const OrderFieldsTaggingItemAddTab = styled.div`
    display: flex;
    align-items: center;
    grid-gap: 1rem;
    gap: 1rem;
    border-radius: 6px;
    background: #f4f6f9;
    width: 100%;
    flex-shrink: 0;
    padding: 1rem !important;
    flex-wrap: wrap;
`;

export const OrderFieldsTaggingTagItem = styled.div`
      border-radius: 33px;
    background: rgba(48, 90, 230, .2);
    display: flex;
    padding: 0 11px;
    justify-content: center;
    align-items: center;
    grid-gap: 8px;
    gap: 8px;
    color: #2555ef;
    font-family: var(--MembersOrderFieldsTaggingTagItemFont-family);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
`;
export const OrderFieldsTaggingSeparator = styled.div`
  background-color: #e7e7eb;
  height: 100%;
  width: 1px;
`;

export const OrderFieldsTaggingStatistics = styled.ul`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-left: 20px;
`;
export const OrderFieldsTaggingStatisticsItem = styled.li`
  font-size: 16px;
  font-weight: 500;
`;

export const OrderFieldsTaggingStatisticsBold = styled.strong`
  font-weight: 600;
`;
export const OrderFieldsTaggingStatisticsLoading = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;